import React from 'react';
import { Svelte } from '../utils/SvelteToReact';
import { Typography as TypographySvelte } from '@glance-networks/ui-core-components';

export type TypographyProps = {
  id?: string;
  tag?: string;
  variant?: string;
  align?: string;
  bodyWeight?: string;
  /** Alias for `bodyWeight` */
  weight?: string;
  className?: string;
  class?: string;
  children?: React.ReactNode;
};

export const Typography = (props: TypographyProps) => {
  const defineProps = {
    id: props.id,
    tag: props.tag,
    variant: props.variant,
    align: props.align,
    // ui-core-components expects `bodyWeight`; allow `weight` as alias for convenience
    bodyWeight: props.bodyWeight ?? props.weight,
    class: props.className ?? props.class,
  };

  return (
    <Svelte component={TypographySvelte} {...defineProps}>
      {props.children}
    </Svelte>
  );
};